import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[app-team-member-card]',
    templateUrl: './team-member-card.component.html',
    styleUrls: ['./team-member-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeamMemberCardComponent {
  @Input() name: string;
  @Input() title: string;
  @Input() imageSrc: string;
  @Input() linkedin: string;
  @Input() web: string;
  @Input() publications: string;
  @Input() hasDefaultBackground = false;
}
